import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface SearchSelectOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-search-select',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './search-select.html',
})
export class SearchSelectComponent {

  @Input() options: SearchSelectOption[] = [];
  @Input() value = '';
  @Input() placeholder = 'Select an option';
  @Input() searchPlaceholder = 'Search...';
  @Input() className = '';

  @Output() valueChange = new EventEmitter<string>();

  isOpen = false;
  searchText = '';
  filteredOptions: SearchSelectOption[] = [];

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  get selectedLabel(): string {
    return this.options.find(o => o.value === this.value)?.label ?? '';
  }

  toggleOpen(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.searchText = '';
      this.filteredOptions = this.options;
    }
  }

  onSearchInput(query: string): void {
    const q = query.trim().toLowerCase();
    this.filteredOptions = !q
      ? this.options
      : this.options.filter(o => o.label.toLowerCase().includes(q));
  }

  selectOption(option: SearchSelectOption): void {
    this.value = option.value;
    this.valueChange.emit(option.value);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }
}
